import { CUSTOM_OPTION_ID } from '@/shared/ui';

import { Address } from '../model/types';

interface Options {
  addressEqualValue?: Nullable<boolean>;
}

export const generateAddress = (address: Record<string, any>, options?: Options): Address => {
  const addressEqualValue = options?.addressEqualValue ?? null;

  const rawAddress: Record<string, any> = {
    country: address.country ? address.country : null,
    region: address.region ? address.region : null,
    district: address.district ? address.district : null,
    settlement: address.settlement ? address.settlement : null,
    street: address.street ? address.street : null,
    custom_street: address.custom_street ? address.custom_street : null,
  };

  return {
    ...Object.keys(rawAddress).reduce<Omit<Address, 'address_equal' | 'building' | 'apartment' | 'house'>>(
      (acc, curr) => {
        const val = rawAddress[curr];

        if (curr === 'custom_street') {
          return acc;
        } else if (curr === 'settlement') {
          acc.settlement_id = typeof val === 'object' && val !== null ? val.id : null;
          acc.settlement_name = typeof val === 'object' && val !== null ? val.label : (val as string | null);
        } else if (curr === 'street') {
          acc.street_id = typeof val === 'object' && val !== null && val.id !== CUSTOM_OPTION_ID ? val.id : null;
          acc.street_name =
            typeof val === 'object' && val !== null
              ? val.id === CUSTOM_OPTION_ID
                ? rawAddress['custom_street']
                : val.label
              : (val as string | null);
        } else if (val && typeof val === 'object' && 'id' in val && 'label' in val) {
          (acc as any)[`${curr}_id`] = (val as any).id;
          (acc as any)[`${curr}_name`] = (val as any).label;
        } else {
          (acc as any)[`${curr}_name`] = val as string;
          (acc as any)[`${curr}_id`] = null;
        }

        return acc;
      },
      {
        country_id: null,
        country_name: '',
        region_id: null,
        region_name: '',
        district_id: null,
        district_name: '',
        settlement_id: null,
        settlement_name: null,
        street_name: null,
        street_id: null,
      },
    ),
    house: address.house ?? null,
    building: address.building ?? null,
    apartment: address.apartment ?? null,
    ...(addressEqualValue !== null && { address_equal: addressEqualValue }),
  };
};
